import classNames from "classnames";
import { get } from "lodash";
import PropTypes from "prop-types";
import Tooltip from "shared/components/Tooltip";
import { HOT_LIST } from "utils/constants";

const formatPoints = (value) => Number(value || 0).toFixed(1);

const formatDecline = (value) =>
  new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value);

const HeatDetails = ({ details, translate }) => (
  <div className="heat-badge__details">
    <div className="heat-badge__details-row">
      <span>{translate.DETAILS.ORIGIN}</span>
      <span>{formatPoints(get(details, "origin"))}</span>
    </div>
    <div className="heat-badge__details-row">
      <span>{translate.DETAILS.FRESHNESS}</span>
      <span>{formatPoints(get(details, "freshness"))}</span>
    </div>
    {get(details, "signals", []).map((signal) => (
      <div
        key={`${signal.type}-${signal.at}`}
        className="heat-badge__details-row"
      >
        <span>{get(translate.DETAILS.SIGNALS, signal.type, signal.type)}</span>
        <span>{formatPoints(signal.points)}</span>
      </div>
    ))}
  </div>
);

HeatDetails.propTypes = {
  details: PropTypes.object,
  translate: PropTypes.object.isRequired,
};

const HeatBadge = ({ project, movement, decay, translate }) => {
  const tierName = get(HOT_LIST.TIERS, get(project, "heatTier"));
  if (!tierName) return null;
  const rise = get(movement, "rise", 0);
  return (
    <Tooltip
      title={
        <div>
          <div className="heat-badge__details-title">
            {get(translate.TIERS, tierName)}
          </div>
          <HeatDetails
            details={get(project, "heatDetails")}
            translate={translate}
          />
        </div>
      }
    >
      <span className={classNames("heat-badge", `heat-badge--${tierName}`)}>
        <span className="heat-badge__dot" />
        <span className="heat-badge__score">
          {Math.round(get(project, "heatScore", 0))}
        </span>
        {movement && (
          <span className="heat-badge__delta heat-badge__delta--up">
            {rise > 0 ? `▲ ${rise}` : "▲"}
          </span>
        )}
        {!movement && decay && (
          <span className="heat-badge__delta heat-badge__delta--down">
            {`▼ ${formatDecline(decay)}`}
          </span>
        )}
      </span>
    </Tooltip>
  );
};

HeatBadge.propTypes = {
  project: PropTypes.object.isRequired,
  movement: PropTypes.object,
  decay: PropTypes.number,
  translate: PropTypes.object.isRequired,
};

export default HeatBadge;
